import * as React from 'react';
import Header from '../common/Header';
import AdminFooter from '../common/AdminFooter';

export interface Props {
    isRegisteredUserFacing?: boolean;
    showHeaderPhoneNumber?: boolean;
}

class StandardLayout extends React.Component<Props, {}> {
    constructor(props: Props) {
        super(props);
    }

    render() {
        const isRegisteredUserFacing =
            this.props.isRegisteredUserFacing !== undefined
                ? this.props.isRegisteredUserFacing
                : true;
        const showPhoneNumber =
            this.props.showHeaderPhoneNumber !== undefined
                ? this.props.showHeaderPhoneNumber
                : false;
        return (
            <div className="flex-root">
                <Header
                    isRegisteredUserFacing={isRegisteredUserFacing}
                    showPhoneNumber={showPhoneNumber}
                />
                {this.props.children}
                <AdminFooter />
            </div>
        );
    }
}

export default StandardLayout;



// WEBPACK FOOTER //
// ./src/components/layouts/StandardLayout.tsx